// extracted by mini-css-extract-plugin
export default {"heading":"ContactSalesTemplate-module__heading--V1yaN"};